import { assignedTasks, unassignedTasks } from '@dispatch/shared/services';
import { useQueries } from 'react-query';

export const useGetResourcesTasks = (resourceId: string) => {
  return useQueries([
    {
      queryKey: ['resource-tasks-assigned', resourceId],
      queryFn: () => assignedTasks(resourceId),
    },
    {
      queryKey: ['resource-tasks-unassigned', resourceId],
      queryFn: () => unassignedTasks(resourceId),
    },
  ]);
};
